import * as React from "react";
import Table from "src/packages/table/Table";
import Code from "src/components/Code";
import CodeBox from "src/components/CodeBox";
import Space from "src/components/Space";
import { renderString } from "src/utils/renderCode";
import Button from "src/packages/button/Button";

const componentName = "TableExample";

class TableExample extends React.Component<{}, any> {
  public static displayName = componentName;

  constructor(props: {}) {
    super(props);
    const nameArray = [
      "Jack",
      "Bob",
      "Ethan",
      "Jim",
      "Lucy",
      "Annie",
      "Lily",
      "Tom"
    ];
    const array = [];
    for (let i = 0; i < 8; i++) {
      array.push({
        key: `dataSource${i + 1}`,
        name: nameArray[i],
        age: Math.floor(Math.random() * 20 + 20 - 1),
        column1: "column 1",
        column2: "column 2",
        column3: "column 3",
        address: `浙江省杭州市西湖区湖底公园${i + 1}号`
      });
    }
    const pageSource = [];
    for (let i = 0; i < 50; i++) {
      pageSource.push({
        key: `pageSource${i + 1}`,
        name: `John Brown ${i + 1}`,
        age: Math.floor(Math.random() * 20 + 20 - 1),
        column1: "column 1",
        column2: "column 2",
        column3: "column 3",
        address: `浙江省杭州市西湖区湖底公园${i + 1}号`
      });
    }
    this.state = {
      columns: [
        {
          title: "姓名",
          key: "name",
          sort: true,
          width: 130,
          fixed: "left",
          headStyle: { display: "inline-flex" },
          style: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
          }
        },
        {
          title: "年龄",
          key: "age",
          sort: true,
          width: 100,
          headStyle: { display: "inline-flex" },
          style: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
          }
        },
        {
          title: "Column 1",
          key: "column1",
          width: 100,
          style: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
          }
        },
        {
          title: "Column 2",
          key: "column2",
          width: 100,
          style: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
          }
        },
        {
          title: "Column 3",
          key: "column3",
          width: 100,
          style: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
          }
        },
        {
          title: "住址",
          key: "address",
          width: 0,
          style: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            fontSize: "12px"
          }
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          fixed: "right",
          render: (key: string, index: number) => (
            <Button
              type="danger"
              size="small"
              style={{ padding: "0 4px", fontSize: "10px" }}
              onClick={() => this.handleClickAction(key, index)}
            >
              删除
            </Button>
          ),
          style: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
          }
        }
      ],
      dataSource: array,
      pageSource,
      loading: true
    };
  }

  public handleClickAction = (key: string, index: number) => {
    this.setState({
      dataSource: this.state.dataSource.filter((data: any) => data.key !== key),
      pageSource: this.state.pageSource.filter((data: any) => data.key !== key)
    });
  };

  public render() {
    return (
      <div className="table-example">
        <section>
          <h1>Table 表格</h1>
          <p className="text">展示行列数据。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">需要展示大量结构化的数据时。</p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div className="container" style={{ display: "block" }}>
            <Table
              columns={this.state.columns}
              dataSource={this.state.dataSource}
              selectCol={true}
            />
          </div>
          <CodeBox title="基本用法" description="基本的用法。">
            {renderString(`import Table from 'xue-react'`)}
            <Code
              code={`&lt;Table columns={this.state.columns} dataSource={this.state.dataSource} selectCol={true} /&gt;`}
            />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: "block" }}>
            <Table
              columns={this.state.columns}
              dataSource={this.state.dataSource}
              selectCol={true}
              loading={this.state.loading}
            />
            <br />
            <Button
              type="primary"
              onClick={() => this.setState({ loading: !this.state.loading })}
            >
              Toggle
            </Button>
          </div>
          <CodeBox title="加载中" description="加载中状态。">
            {renderString(`import Table from 'xue-react'`)}
            <Code
              code={`&lt;Table columns={this.state.columns} dataSource={this.state.dataSource} selectCol={true} loading={this.state.loading} /&gt;`}
            />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: "block" }}>
            <Table
              columns={this.state.columns}
              dataSource={this.state.dataSource}
              selectCol={true}
              scroll={{ y: 200 }}
            />
          </div>
          <CodeBox
            title="固定表头"
            description="设置 scroll.y 以固定表头。需要指定 column 的 width 属性，否则列头和内容可能不对齐。（建议留一列设置宽度为 0 以适应弹性布局）"
          >
            <span className="htmltag">const </span>
            <span className="property">scrollY</span>
            <span className="htmlstr">= {"{ "}</span>
            <span className="property">y: </span>
            <span className="num">200 </span>
            <span className="htmlstr">{"}"}</span>
            <br />
            {renderString(`import Table from 'xue-react'`)}
            <Code
              code={`&lt;Table columns={this.state.columns} dataSource={this.state.dataSource} scroll={scrollY} selectCol={true} /&gt;`}
            />
          </CodeBox>
        </div>
        <div className="example">
          <div
            className="container"
            style={{ display: "block", width: "800px" }}
          >
            <Table
              columns={this.state.columns}
              dataSource={this.state.dataSource}
              scroll={{ x: 1000 }}
              rowHeight={60}
              selectCol={true}
            />
          </div>
          <CodeBox
            title="固定列"
            description="对于列数很多的数据，可以固定前后的列，横向滚动查看其它数据，需要和 scroll.x 配合使用。默认固定第一列和最后一列，也可以设置 column 的 fixed 属性以固定对应列。若固定列与其他列内容不对齐，请指定行的高度 rowHeight。"
          >
            <span className="htmltag">const </span>
            <span className="property">scrollX</span>
            <span className="htmlstr">= {"{ "}</span>
            <span className="property">x: </span>
            <span className="num">1000 </span>
            <span className="htmlstr">{"}"}</span>
            <br />
            {renderString(`import Table from 'xue-react'`)}
            <Code
              code={`&lt;Table columns={this.state.columns} dataSource={this.state.dataSource} scroll={scrollX} rowHeight={60} selectCol={true} /&gt;`}
            />
          </CodeBox>
        </div>
        <div className="example">
          <div
            className="container"
            style={{ display: "block", width: "800px" }}
          >
            <Table
              columns={this.state.columns}
              dataSource={this.state.dataSource}
              scroll={{ x: 1000, y: 300 }}
              rowHeight={60}
            />
          </div>
          <CodeBox
            title="固定表头和列"
            description="适合同时展示有大量数据和数据列。"
          >
            <span className="htmltag">const </span>
            <span className="property">scroll</span>
            <span className="htmlstr">= {"{ "}</span>
            <span className="property">x: </span>
            <span className="num">1000</span>
            <span className="htmlstr">, </span>
            <span className="property">y: </span>
            <span className="num">300 </span>
            <span className="htmlstr">{"}"}</span>
            <br />
            {renderString(`import Table from 'xue-react'`)}
            <Code
              code={`&lt;Table columns={this.state.columns} dataSource={this.state.dataSource} scroll={scroll} rowHeight={60} /&gt;`}
            />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: "block" }}>
            <Table
              columns={this.state.columns}
              dataSource={this.state.dataSource}
              stripe={true}
              size="small"
            />
          </div>
          <CodeBox title="紧凑型" description="紧凑型的列表。">
            {renderString(`import Table from 'xue-react'`)}
            <Code
              code={`&lt;Table columns={this.state.columns} dataSource={this.state.dataSource} stripe={true} size="small" /&gt;`}
            />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: "block" }}>
            <Table
              columns={this.state.columns}
              dataSource={this.state.pageSource}
              border={true}
              selectCol={true}
              pager={true}
            />
          </div>
          <CodeBox
            title="带边框、分页功能"
            description="添加表格边框、分页功能。"
          >
            {renderString(`import Table from 'xue-react'`)}
            <Code
              code={`&lt;Table columns={this.state.columns} dataSource={this.state.dataSource} border={true} selectCol={true} pager={true} /&gt;`}
            />
          </CodeBox>
        </div>
        <section>
          <h2>API</h2>
        </section>
        <section className="sub">
          <h3>Table</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>columns</td>
              <td className="des">表格列的配置数组，具体属性设置见 Column</td>
              <td className="type">Column[]</td>
              <td>——</td>
            </tr>
            <tr>
              <td>dataSource</td>
              <td className="des">数据数组，具体属性设置见 Data</td>
              <td className="type">Data[]</td>
              <td>——</td>
            </tr>
            <tr>
              <td>selectCol</td>
              <td className="des">是否展示选择列</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>onSelectChange</td>
              <td className="des">选中的行改变时的回调</td>
              <td className="type">(selectedKeys: string[]) => any</td>
              <td>——</td>
            </tr>
            <tr>
              <td>size</td>
              <td className="des">表格尺寸</td>
              <td className="type">'default' | 'small'</td>
              <td>'default'</td>
            </tr>
            <tr>
              <td>stripe</td>
              <td className="des">斑马纹</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>border</td>
              <td className="des">带边框</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>pager</td>
              <td className="des">分页功能</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>pageSize</td>
              <td className="des">分页模式下每页显示的数据行数</td>
              <td className="type">number</td>
              <td>10</td>
            </tr>
            <tr>
              <td>scroll</td>
              <td className="des">固定表头、列的配置，具体属性设置见 Scroll</td>
              <td className="type">Scroll</td>
              <td>——</td>
            </tr>
            <tr>
              <td>rowHeight</td>
              <td className="des">行高。单位：px</td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
            <tr>
              <td>loading</td>
              <td className="des">加载中状态</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>spinSize</td>
              <td className="des">加载图标大小。单位：px</td>
              <td className="type">number</td>
              <td>30</td>
            </tr>
          </tbody>
        </table>
        <section className="sub">
          <h3>Column</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>title</td>
              <td className="des">表格头</td>
              <td className="type">string | React.ReactNode</td>
              <td>——</td>
            </tr>
            <tr>
              <td>key</td>
              <td className="des">
                列数据在 Data 中对应的 key、表格列的唯一标志
              </td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>width</td>
              <td className="des">
                表格列的宽度，单位：px。设置为 0 时为弹性列
              </td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
            <tr>
              <td>sort</td>
              <td className="des">
                是否可排序，无 sorter 函数时提供升序、降序两种排序方式
              </td>
              <td className="type">boolean</td>
              <td>——</td>
            </tr>
            <tr>
              <td>sorter</td>
              <td className="des">排序函数</td>
              <td className="type">(rowA: Data, rowB: Data) => any</td>
              <td>——</td>
            </tr>
            <tr>
              <td>render</td>
              <td className="des">
                生成复杂数据的渲染函数，参数分别为当前行数据的 key 和索引
              </td>
              <td className="type">
                (key: string, index: number) => string | React.ReactNode
              </td>
              <td>——</td>
            </tr>
            <tr>
              <td>headClassName</td>
              <td className="des">自定义列表头容器类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>headStyle</td>
              <td className="des">自定义列表头容器样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义列表格容器类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义列表格容器样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
        <section className="sub">
          <h3>Data</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>key</td>
              <td className="des">表格行的唯一标志</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>propName</td>
              <td className="des">对应列的渲染内容</td>
              <td className="type">string | React.ReactNode</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
        <section className="sub">
          <h3>Scroll</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>x</td>
              <td className="des">固定列时表格的宽度，单位：px</td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
            <tr>
              <td>y</td>
              <td className="des">
                固定表头时表格的高度（不包括表头），单位：px
              </td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default TableExample;



// WEBPACK FOOTER //
// ./src/examples/Table.example.tsx